function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarn = function SvgWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21990"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 20005",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17772",
    d: "M18 10a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-7 4a1 1 0 1 1-1-1 1 1 0 0 1 1 1zm-1-9a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1z",
    transform: "translate(5 5)",
    style: {
      fill: "#ffb55f",
      fillRule: "evenodd"
    }
  })));
};

export default SvgWarn;